import { computed } from 'vue';

import { toCardTransactionTableRow } from '../internal/utils/card-transaction-row';
import { useCardsStore } from '../store/cards.store';

export const useCardTransactionRows = () => {
  const cardsStore = useCardsStore();

  return computed(() =>
    cardsStore.cards.flatMap((card) =>
      cardsStore
        .transactionsForCard(card.id)
        .map((transaction) => toCardTransactionTableRow(transaction, card)),
    ),
  );
};
